import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartPieSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M30.9625 15H17V1.03625C17 0.472188 17.3813 0 18 0C25.7313 0 32 6.26875 32 14C32 14.5625 31.525 15 30.9625 15ZM11.8875 2.32375C13.0188 2.085 14 3.0125 14 4.16875V18H27.8312C28.9875 18 29.9125 18.9812 29.675 20.1125C28.2437 26.9062 22.2188 32 15 32C6.71875 32 0 25.2875 0 17C0 9.78125 5.09562 3.7575 11.8875 2.32375Z" })
});
export default SvgChartPieSimple;
